import createAxiosInstance from 'src/utils/createAxiosInstance';
import { CLIENT_PORTAL_API_URL, EARCHIVE_LITE_API_URL } from 'src/utils/constants';

export const clientPortalApi = createAxiosInstance(CLIENT_PORTAL_API_URL);
export const earchiveLiteApi = createAxiosInstance(EARCHIVE_LITE_API_URL);
